import { render, staticRenderFns } from "./Emissao.vue?vue&type=template&id=ae8d128a&"
import script from "./Emissao.vue?vue&type=script&lang=js&"
export * from "./Emissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports